import { render } from "./AppSidebarMenu.vue?vue&type=template&id=85e4cb36"
import script from "./AppSidebarMenu.vue?vue&type=script&lang=js"
export * from "./AppSidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__